export default "__VITE_ASSET__08f03949__"